import { render, staticRenderFns } from "./App.vue?vue&type=template&id=5097b3b1&scoped=true&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=5097b3b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5097b3b1",
  null
  
)

export default component.exports